module.exports = __webpack_public_path__ + "img/5.92cc445b.jpg";